import TrackCustomerUpdate from './track_customer_update';

export default class ChangeName {
  constructor(context) {
    this.context = context;
  }

  run(newName) {
    newName = newName.trim();

    let customerProfile = this.context.stores.profile.get();
    customerProfile.changeName(newName);

    this.context.stores.profile.setPending(customerProfile);
    this.context.gateways.customerProfile.update({ customerId: this.currentCustomerId }, { name: newName });

    this.context.executeAction(TrackCustomerUpdate, {
      customerId: this.currentCustomerId,
      field: 'name',
    });
  }

  get currentCustomerId() {
    return this.context.stores.currentLocation.get().customerId;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer_profile/change_name.js